<template>
  <v-card flat rounded="lg">
    <v-card-title
      class="font-weight-bold"
      v-if="dadosCadastrais && dadosCadastrais.numeros_telefone.length > 0"
      >Insira o código de segurança que enviamos por {{ enviarCodigoVia }} para
      {{ getNumeroOculto() }}</v-card-title
    >
    <v-card-text>
      <v-form ref="form" class="mt-3">
        <v-row dense>
          <v-col xl="3" lg="3" md="3" cols="12">
            <v-otp-input length="6" type="number" class="campo-codigo-recebido" v-model="codigoRecebidoModel" ></v-otp-input>
            <!-- <v-text-field
              outlined
              label="Código recebido"
              class="campo-codigo-recebido"
              v-mask="'######'"
              
              :rules="[(v) => v.length == 6 || 'Código deve conter 6 dígitos']"              
            ></v-text-field> -->
          </v-col>
        </v-row>

        <v-row dense class="mt-2">
          <v-col xl="auto" lg="auto" md="auto" cols="12">
            <v-btn
              rounded
              :block="isMobile()"
              color="success"
              class="font-weight-bold"
              @click="validarCodigo()"
              :loading="validandoCodigo"
              min-width="150"
              >Confirmar</v-btn
            >
          </v-col>
          <v-col xl="auto" lg="auto" md="auto" cols="12">
            <v-btn
              rounded
              text
              color="info"
              block
              @click="setStep(step - 1)"
              class="font-weight-bold"
              >Enviar novo código</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions> </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState("atualizacaoCadastral", ["dadosCadastrais"]),
    ...mapState("configComprasPrazo", [
      "step",
      "enviarCodigoVia",
      "codigoRecebido",
      "telefoneSelecionado",
      "validandoCodigo",
    ]),
    codigoRecebidoModel: {
      get: function () {
        return this.codigoRecebido;
      },
      set: function (value) {
        this.setCodigoRecebido(value);
      },
    },
  },
  methods: {
    ...mapMutations("configComprasPrazo", ["setStep", "setCodigoRecebido"]),
    ...mapActions("configComprasPrazo", ["validarCodigoSeguranca"]),
    getNumeroOculto() {
      try {
        return this.dadosCadastrais.numeros_telefone.find(
          (nt) => nt.numero_completo == this.telefoneSelecionado
        ).numero_oculto;
      } catch (error) {
        return "";
      }
    },
    isMobile() {
      return this.$mq == "sm";
    },
    async validarCodigo() {
      if (this.$refs.form.validate()) {
        await this.validarCodigoSeguranca();
      }
    },
  },
};
</script>

<style>
.campo-codigo-recebido input {
  letter-spacing: 5px !important;
  text-align: center;
  font-size: 1.7rem !important;
  font-family: "archivo black" !important;
}
</style>